// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1BnOp","emails":"CreateEditClinics_emails__V1Lti","emailTagLabel":"CreateEditClinics_emailTagLabel__7DIZX"};